import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { followRider, unfollowRider } from "../../../redux/actions/riderNetworkActions";
import { toast } from "react-toastify";

function FollowingStatusControl({
    user,
    subjectUser,
    followRider,
    unfollowRider
}) {

    const [beenBlocked, setBeenBlocked] = useState(false);
    const [following, setFollowing] = useState(false);
    const [pending, setPending] = useState(false);

    //const [rejected, setRejected] = useState(false);
    


    useEffect(() => {
        if (user.riderNetwork.following) {
            user.riderNetwork.following.map(subject => {
                if (subject.userId.toLowerCase() == subjectUser.userId.toLowerCase()) {
                    setFollowing(true);
                    if (subject.blocked) setBeenBlocked(true);
                    if (subject.pending) setPending(true);
                }
            })
        }
    }, [])

    function followUser(e) {
        e.preventDefault();
        subjectUser.id = subjectUser.userId; 
        followRider(subjectUser, subjectUser.approveFollowers);
        setFollowing(true);
        setPending(subjectUser.approveFollowers)
        toast.success(subjectUser.approveFollowers ? "Follow Request Submitted" : `Following ${subjectUser.firstName}`);
    }

    function unfollowUser(e) {
        e.preventDefault();
        subjectUser.id = subjectUser.userId; 
        unfollowRider(subjectUser);
        setFollowing(false);
        toast.success(subjectUser.pending ? "Follow Request Cancelled" : `Unfollowed ${subjectUser.firstName}`);
    }

    return (
        <div className="profile-status-control">
            { user.id.toUpperCase() == subjectUser.userId.toUpperCase() || beenBlocked ? "" :
                following ?
                    <React.Fragment>
                        {pending ?  <span className="badge badge-pill badge-info float-left">Request Pending</span> : ""}
                        <div className="dropdown dropleft float-right">
                            <button className="btn btn-link" id="dLabel" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span className="fas fa-ellipsis-h more-options"></span>
                            </button>

                            <div className="dropdown-menu" aria-labelledby="dLabel">
                                <a className="dropdown-item" onClick={unfollowUser} href="#">{pending ? "Cancel Request" : "Unfollow"}</a>
                            </div>
                        </div>
                    </React.Fragment>
                    :
                    <button className="btn btn-sm btn-info" onClick={followUser}>{subjectUser.approveFollowers ? "Request to Follow" : "Follow"}</button>
            }
        </div>
    );
};

FollowingStatusControl.propTypes = {
    user: PropTypes.object.isRequired,
    subjectUser: PropTypes.object.isRequired,
    followRider: PropTypes.func.isRequired,
    unfollowRider: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
    followRider,
    unfollowRider
}

export default connect(mapStateToProps, mapDispatchToProps)(FollowingStatusControl);




// WEBPACK FOOTER //
// ./src/components/user/profile/FollowingStatusControl.js